export default __webpack_public_path__ + "static/media/waiting-action-120.e3d1c06b.png";